// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"388":"6f657d01","755":"77d540e8","908":"50fd9688","933":"eda73352","975":"ff936550","979":"65527c10"}[chunkId] + ".css";
};